import {AppState} from "../../redux/reducers/rootReducer"

export default function isInternOnly(state: AppState): boolean {
    return state.core.user.internOnly
}

export function userRoles(state: AppState): string[] {
    return state.core.user.roles
}

export function showDisclaimer(state: AppState): boolean {
    return state.core.user.showDisclaimer
}

export const getDatabase = (state: AppState): string => state.core.database
